import type KeyboardInjector from '../components/keyboard-injector/KeyboardInjector.js';

/**
 * Utility for finding keyboard injector in document.
 */
export default class KeyboardInjectorFinder {
	/**
	 * Finds KeyboardInjector in document.
	 *
	 * @returns Keyboard injector.
	 */
	public static findKeyboardInjectorElement(): KeyboardInjector | null {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		if (!(window as any).$ikeaKompisKeyboardInjectorTagNames) {
			return null;
		}
		return <
			KeyboardInjector | null // eslint-disable-next-line @typescript-eslint/no-explicit-any
		>document.querySelector((window as any).$ikeaKompisKeyboardInjectorTagNames.join(','));
	}
}
